import React from "react";
import { Container, Grid, Link } from "@mui/material";
import Heading from "../../components/Heading/heading";

import twitter from '../../image/twitter.png'
import telegram from '../../image/telegram.png'
import ETHScan from '../../image/ETHScan.png'
import CMC from '../../image/CMC.png'
import CG from '../../image/CG.png'
import header_img from '../../image/header_img.png'

import logo from '../../image/footer_logo.png'

const Footer = () => {
    return(
        <div>
            <div className="SP---footer mt-4">
                <Container maxWidth="lg">
                    <Grid
                        container
                        justifyContent='flex-start'
                        alignItems="flex-start"
                        className="py-sm-5"
                    >
                        <Grid
                            xs={12}
                            sm={10}
                        >
                            <Link to="/">
                                <img src={logo} className="img-fluid w-100" style={{maxWidth: 170}} />
                            </Link>
                            <p className="text-light my-4" style={{maxWidth:300}}>
                                ShibaPup is a BSC long term token built on Binance Smart Chain focused in the dog driven community, we all are Pup lovers!
                            </p>
                            <div className="SE---footer_email">
                                <input type="email" placeholder="Email" />
                                <button className="btn">Send</button>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={2}
                            className="text-center"
                        >
                            <h5 className="text-left text-light mb-3 mt-5 mt-sm-0">Navigation</h5>
                            <Link href="/#" className="d-block text-light text-left">
                                Home
                            </Link>
                            <Link href="/#tokenomics" className="d-block text-light text-left">
                                Tokenomics
                            </Link>
                            <Link href="/#features" className="d-block text-light text-left">
                                Features
                            </Link>
                            <Link href="/#play-to-earn" className="d-block text-light text-left">
                                Play to Earn
                            </Link>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <p className="text-center py-4 mb-0">© Shiba Pup All rights reserved Copyrights 2021</p>
        </div>
    )
}

export default Footer;